import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ReducedService } from './service.model';
import { throwError } from 'rxjs';
import { Service } from './service-details/service-details.model';
import { LogService } from 'src/app/shared/services/log.service';
import { ICalendar } from './iCalendar.model';
import { ServiceLeader, UpdateLeader } from 'src/app/shared/models/service-leader.model';

@Injectable({ providedIn: 'root' })
export class ServiceService {
  apiHost: string = environment.apiHost;
  ServiceArr: ReducedService[] = [];
  constructor(
    private http: HttpClient,
    private router: Router,
    private logService: LogService
  ) {}

  getAllServices(): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .get<any[]>(this.apiHost + '/Service/GetAll')
        .toPromise()
        .then(
          (data) => {
            resolve(data.sort((a, b) => (a.name < b.name ? -1 : 1)));
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get All Services', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getServicesByCategory(category): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .get<any[]>(this.apiHost + '/Service/getServicesByCategory?Category='+category.toString())
        .toPromise()
        .then(
          (data) => {
            resolve(data.sort((a, b) => (a.name < b.name ? -1 : 1)));
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Services By Category', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }  

  getService(ServiceId: number): Promise<Service> {
    let promise = new Promise<Service>((resolve, reject) => {
      return this.http
        .get<Service>(
          this.apiHost + '/Service/get?ServiceId=' + ServiceId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Active', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getLeaders(): Promise<ServiceLeader[]> {
    let promise = new Promise<ServiceLeader[]>((resolve, reject) => {
      return this.http
        .get<ServiceLeader[]>(
          this.apiHost + '/Service/getLeaders'
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get Leaders', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }    

  getServiceLeaders(ServiceId: number): Promise<ServiceLeader[]> {
    let promise = new Promise<ServiceLeader[]>((resolve, reject) => {
      return this.http
        .get<ServiceLeader[]>(
          this.apiHost + '/Service/getServiceLeaders?ServiceId=' + ServiceId.toString()
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get ServiceLeaders', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }  

  updateServiceLeaders(ServiceId: number, serviceLeaders: UpdateLeader[]): Promise<ServiceLeader[]> {
    let promise = new Promise<ServiceLeader[]>((resolve, reject) => {
      return this.http
        .post<ServiceLeader[]>(
          this.apiHost + '/Service/UpdateLeaders?ServiceId=' + ServiceId.toString(), serviceLeaders
        )
        .toPromise()
        .then( 
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update ServiceLeaders', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }    

  deleteService(ServiceId: number): Promise<ReducedService> {
    let promise = new Promise<ReducedService>((resolve, reject) => {
      return this.http
        .post<ReducedService>(
          this.apiHost + '/Service/delete?ServiceId=' + ServiceId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Delete Service', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  addService(Service: Service): Promise<Service> {
    let promise = new Promise<Service>((resolve, reject) => {
      return this.http
        .post<Service>(this.apiHost + '/Service/Add', Service)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Add Service', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  updateService(Service: Service): Promise<Service> {
    let promise = new Promise<Service>((resolve, reject) => {
      return this.http
        .post<Service>(this.apiHost + '/Service/Update', Service)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update Service', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  undeleteService(ServiceId: number): Promise<ReducedService> {
    let promise = new Promise<ReducedService>((resolve, reject) => {
      return this.http
        .post<ReducedService>(
          this.apiHost + '/Service/undelete?ServiceId=' + ServiceId.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Undelete Service', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  UpdateServiceSlots(
    ServiceId: number,
    BlockForAdmin: number,
    hoursToNotifyByEmail: number,
    hoursToNotifyByText: number,
    applyToHidden: boolean
  ): Promise<any[]> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .post<any[]>(
          this.apiHost +
            '/Service/UpdateSlots?ServiceId=' +
            ServiceId.toString() +
            '&BlockForAdmin=' +
            BlockForAdmin.toString() +
            '&email=' + 
            hoursToNotifyByEmail.toString() +
            '&text=' +
            hoursToNotifyByText.toString() +
            '&applyToHidden=' +
            applyToHidden.toString(),
          null
        )
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Update service slots', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  refreshAll(): Promise<any> {
    let promise = new Promise<any[]>((resolve, reject) => {
      return this.http
        .post<any[]>(this.apiHost + '/Service/Refreshall', null)
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Service RefreshAll', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }

  getAllEvents(): Promise<ICalendar[]> {
    let promise = new Promise<ICalendar[]>((resolve, reject) => {
      return this.http
        .get<ICalendar[]>(this.apiHost + '/Event/GetAllEvents')
        .toPromise()
        .then(
          (data) => {
            resolve(data);
          },
          (msg) => {
            if (this.logService != null)
              this.logService.addToLog('Admin: Get all Events', msg);
            reject(msg);
          }
        );
    });
    return promise;
  }
}
